import { render, staticRenderFns } from "./MaterialDevForm.vue?vue&type=template&id=e6ba52da&scoped=true&"
import script from "./MaterialDevForm.vue?vue&type=script&lang=js&"
export * from "./MaterialDevForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDevForm.vue?vue&type=style&index=0&id=e6ba52da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ba52da",
  null
  
)

export default component.exports